import { ModelsRowType, ModelListProps } from "../../types/models";
import React, { useEffect, useState } from 'react';
import {ReactComponent as Icon } from '../../assets/icons/Edit.svg'
import { useNavigate } from 'react-router-dom';
import TableMedusa from '../../components/Table';
import { Table, Button } from '@mantine/core';
import {ReactComponent as RemoveIcon} from '../../assets/icons/Remove.svg'
import PopUp from '../../components/PopUp';
import {useDisclosure } from '@mantine/hooks';



const ModelsList = ({ data, activeTab , deleteModel}: ModelListProps) => {
    const navigate = useNavigate();
    const icon = <Icon width={19} height={19}></Icon>;
    const removeIcon = <RemoveIcon width={19} height={19}></RemoveIcon>;
    const [openedDel, handlerDel] = useDisclosure(false);
    const [id, setId] = useState<number | undefined>(undefined);

    const onClickDetail = (id:number | undefined)=>{
        if (id === undefined) return;
        navigate(`/models/${activeTab}/${id}`);
    }

    const onClickRemove = (id:number | undefined)=>{
        if (id === undefined) return;
        setId(id);
        handlerDel.open()
    }

    const onClickDelete = (id:number | undefined)=>{
        if (id !== undefined) {
            deleteModel(id);
        }
        handlerDel.close();
    }

    const rows = data?.map(({ id, name }) => (
        <Table.Tr key={id}>
            <Table.Td>{id}</Table.Td>
            <Table.Td>{name}</Table.Td>
            <Table.Td>
                <Button variant="transparent" onClick={()=>onClickDetail(id)}>{icon}</Button>
                <Button variant="transparent" onClick={()=>onClickRemove(id)}>{removeIcon}</Button>
            </Table.Td>
        </Table.Tr>
    ));

    return (
        <div>
            <PopUp opened={openedDel} close={handlerDel.close} size={700} title="Warning" onSave={() => onClickDelete(id)} button1="Delete" >Are you sure you want to delete this model?</PopUp>
            <TableMedusa headers={["ID", "Name"]} rows={rows}></TableMedusa>
        </div>
    );
};
export default ModelsList;